import { useEffect } from 'react'
import { SurveyEngine_Models_BaseResponse, SurveyEngine_Models_WebCaptureAnswerValues, SurveyEngine_Models_WebCaptureResponse } from '../../../api'
import { useSearchParams } from 'react-router-dom';

interface webCaptureProps {
  id: number,
  params: Array<string>,
  callback: (response: SurveyEngine_Models_BaseResponse) => void
  
}

export const WebCapture = (props:webCaptureProps) => {

  const [searchParams] = useSearchParams();

  function GetAnswerValues(params:string[]){
      const getCaseInsensitiveParam = (key:string) => {
      const entries = searchParams.entries();
      for (let [paramKey, paramValue] of entries) {
        if (paramKey.toLowerCase() === key.toLowerCase()) {
          return paramValue;
        }
      }
      return null;
    };
   
    let answerValues = params.map((value: any, i: any) => {
      let answerValue : SurveyEngine_Models_WebCaptureAnswerValues = {
        name: value,
        value: getCaseInsensitiveParam(value)??""
      }
      return answerValue;
    });
  
    return answerValues;
  }
  useEffect(() => {
  
    let response: SurveyEngine_Models_WebCaptureResponse = {
      commandType: "WebCapture",
      commandIndex: props.id,
      values: GetAnswerValues(props.params)
      
    };
    props.callback(response);
  
  }, [])
  return <></>
}


